import * as React from 'react';

import { Tag } from '@cian/components';

import { IInfrastructureParamTag } from '../../../state/tags/definitions/infrastructure';
import { TInfrastructureParams } from '../../advanced/params/infrastructure';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

const paramsProps = Object.keys(TInfrastructureParams).map(key => TInfrastructureParams[key]);

export interface IInfrastructureParamTagItemProps {
  tag: IInfrastructureParamTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const InfrastructureParamTagItem = (props: IInfrastructureParamTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);
  const param = paramsProps.find(paramProps => paramProps.jqParamName === props.tag.paramName);
  const title = (param && param.name) || '';

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Есть {title.toLowerCase()}
    </TagComponent>
  );
};
